import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const tabLabelStyles = {
  fontFamily: "Noto Sans Hebrew",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  letterSpacing: "0.04em",
  textTransform: "uppercase" as const,
};

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },
  tabBarRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "16px",
    width: "100%",
    height: "42px",
    minHeight: "42px",
    direction: "ltr",
    opacity: 1,
  },
  actionButton: {
    height: "42px",
    minHeight: "42px",
    borderRadius: "4px",
    boxShadow: "none",
    textTransform: "none",
    fontFamily: theme.typography.fontFamily,
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "21px",
    padding: "10px 22px !important",
    backgroundColor: `${theme.palette.primary.main} !important`,
    flexShrink: 0,
    opacity: 1,
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    boxSizing: "border-box",
    "& .MuiButton-startIcon": {
      margin: "0 !important",
    },
    "&:hover": {
      boxShadow: "none",
    },
  },
  tabsWrapper: {
    width: "fit-content",
    maxWidth: "100%",
    height: "42px",
    minHeight: "42px",
    marginLeft: "auto",
    opacity: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "4px",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  tabs: {
    width: "fit-content",
    maxWidth: "100%",
    height: "42px",
    minHeight: "42px",
    opacity: 1,
    flexShrink: 0,
    boxSizing: "border-box",
    "& .MuiTabs-root": {
      height: "42px",
      minHeight: "42px",
    },
    "& .MuiTabs-scroller": {
      overflowX: "auto !important",
      width: "fit-content !important",
      maxWidth: "100%",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "& .MuiTabs-flexContainer": {
      width: "fit-content",
    },
    "& .MuiTab-root": {
      minHeight: "42px",
      height: "42px",
      ...tabLabelStyles,
      textTransform: "uppercase !important",
      color: theme.palette.text.primary,
      padding: 0,
      margin: "0 12px",
      minWidth: "unset",
      maxWidth: "none",
      flexShrink: 0,
      whiteSpace: "nowrap",
      position: "relative",
      opacity: 1,
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 600,
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: "2px",
        backgroundColor: theme.palette.primary.main,
      },
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .MuiTabs-scrollButtons": {
      display: "none",
    },
  },
}));
